/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Add_Group_TitleInputs */

const en_team_manager_add_group_title = /** @type {(inputs: Team_Manager_Add_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add New Group`)
};

const fr_team_manager_add_group_title = /** @type {(inputs: Team_Manager_Add_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un nouveau groupe`)
};

const de_team_manager_add_group_title = /** @type {(inputs: Team_Manager_Add_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Gruppe hinzufügen`)
};

const it_team_manager_add_group_title = /** @type {(inputs: Team_Manager_Add_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi nuovo gruppo`)
};

const ru_team_manager_add_group_title = /** @type {(inputs: Team_Manager_Add_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить новую группу`)
};

const es_team_manager_add_group_title = /** @type {(inputs: Team_Manager_Add_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar nuevo grupo`)
};

const zh_cn2_team_manager_add_group_title = /** @type {(inputs: Team_Manager_Add_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加新组`)
};

const ja_team_manager_add_group_title = /** @type {(inputs: Team_Manager_Add_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいグループを追加`)
};

const hi_team_manager_add_group_title = /** @type {(inputs: Team_Manager_Add_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया समूह जोड़ें`)
};

const pt_pt2_team_manager_add_group_title = /** @type {(inputs: Team_Manager_Add_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar novo grupo`)
};

/**
* | output |
* | --- |
* | "Add New Group" |
*
* @param {Team_Manager_Add_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_group_title = /** @type {((inputs?: Team_Manager_Add_Group_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_Group_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_add_group_title(inputs)
	if (locale === "de") return de_team_manager_add_group_title(inputs)
	if (locale === "it") return it_team_manager_add_group_title(inputs)
	if (locale === "ru") return ru_team_manager_add_group_title(inputs)
	if (locale === "es") return es_team_manager_add_group_title(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_add_group_title(inputs)
	if (locale === "ja") return ja_team_manager_add_group_title(inputs)
	if (locale === "hi") return hi_team_manager_add_group_title(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_add_group_title(inputs)
	return en_team_manager_add_group_title(inputs)
});